var map = {
	"./apple-touch-icon.png": 65129,
	"./browserconfig.xml": 75565,
	"./favicon-16x16.png": 75752,
	"./favicon-32x32.png": 75908,
	"./favicon.ico": 24115,
	"./icon.png": 65626,
	"./icon_120x120.png": 23803,
	"./icon_180x180.png": 19503,
	"./icon_192x192.png": 86551,
	"./icon_512x512.png": 99471,
	"./mstile-150x150.png": 69482,
	"./safari-pinned-tab.svg": 45410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52155;